// This must run before imports that resolve UI icons through webpack's public path.
import '../lib/exam-public-path';

// Polyfills
import 'es6-object-assign/auto';
import 'core-js/fn/array/includes';
import 'core-js/fn/promise/finally';
import 'intl'; // For Safari 9

import React from 'react';
import ReactDOM from 'react-dom';

import AppStateHOC from '../lib/app-state-hoc.jsx';
import BrowserModalComponent from '../components/browser-modal/browser-modal.jsx';
import supportedBrowser from '../lib/supported-browser';

import styles from './index.css';

const appTarget = document.createElement('div');
appTarget.className = styles.app;
const examMount = window.__EXAM_SCRATCH_MOUNT__;
(examMount || document.body).appendChild(appTarget);

if (supportedBrowser()) {
    // require needed here to avoid importing unsupported browser-crashing code
    // at the top level
    require('./render-gui.jsx').default(appTarget);

} else {
    BrowserModalComponent.setAppElement(appTarget);
    const WrappedBrowserModalComponent = AppStateHOC(BrowserModalComponent, true /* localesOnly */);
    const handleBack = () => {};
    // eslint-disable-next-line react/jsx-no-bind
    ReactDOM.render(<WrappedBrowserModalComponent onBack={handleBack} />, appTarget);
}

const bootstrapLoading = document.getElementById('scratch-bootstrap-loading');
if (bootstrapLoading) {
    window.requestAnimationFrame(() => {
        bootstrapLoading.classList.add('is-hiding');
        window.setTimeout(() => bootstrapLoading.remove(), 200);
    });
}
